<template>
  <section
    class="dbc-gl-section--full-screen"
    :data-aos="aos?.fadeDirection"
    :data-aos-delay="aos?.delay"
    :data-aos-offset="aos?.offset"
  >
    <slot />
  </section>
</template>

<script setup lang="ts">
defineProps<{
  aos?: Aos
}>()
</script>
